import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Smart initial language detection
const getInitialLanguage = () => {
  // 1. Check localStorage first (from previous sessions)
  const stored = localStorage.getItem('mellow-ui-language');
  if (stored && ['en', 'zh', 'ru'].includes(stored)) return stored;

  // 2. Detect browser language
  const browserLang = navigator.language.split('-')[0];
  if (['en', 'zh', 'ru'].includes(browserLang)) return browserLang;

  // 3. Default fallback
  return 'en';
};

// Import translation files
import commonEN from './locales/en/common.json';
import authEN from './locales/en/auth.json';
import onboardingEN from './locales/en/onboarding.json';
import navigationEN from './locales/en/navigation.json';
import chatEN from './locales/en/chat.json';
import reviewEN from './locales/en/review.json';
import profileEN from './locales/en/profile.json';
import discoveryEN from './locales/en/discovery.json';
import cardsEN from './locales/en/cards.json';
import errorsEN from './locales/en/errors.json';
import languagesEN from './locales/en/languages.json';
import levelsEN from './locales/en/levels.json';
import settingsEN from './locales/en/settings.json';
import proofreadEN from './locales/en/proofread.json';
import languageCodesEN from './locales/en/languageCodes.json';

import commonZH from './locales/zh/common.json';
import authZH from './locales/zh/auth.json';
import onboardingZH from './locales/zh/onboarding.json';
import navigationZH from './locales/zh/navigation.json';
import chatZH from './locales/zh/chat.json';
import reviewZH from './locales/zh/review.json';
import profileZH from './locales/zh/profile.json';
import discoveryZH from './locales/zh/discovery.json';
import cardsZH from './locales/zh/cards.json';
import errorsZH from './locales/zh/errors.json';
import languagesZH from './locales/zh/languages.json';
import levelsZH from './locales/zh/levels.json';
import settingsZH from './locales/zh/settings.json';
import proofreadZH from './locales/zh/proofread.json';
import languageCodesZH from './locales/zh/languageCodes.json';

import commonRU from './locales/ru/common.json';
import authRU from './locales/ru/auth.json';
import onboardingRU from './locales/ru/onboarding.json';
import navigationRU from './locales/ru/navigation.json';
import chatRU from './locales/ru/chat.json';
import reviewRU from './locales/ru/review.json';
import profileRU from './locales/ru/profile.json';
import discoveryRU from './locales/ru/discovery.json';
import cardsRU from './locales/ru/cards.json';
import errorsRU from './locales/ru/errors.json';
import languagesRU from './locales/ru/languages.json';
import levelsRU from './locales/ru/levels.json';
import settingsRU from './locales/ru/settings.json';
import proofreadRU from './locales/ru/proofread.json';
import languageCodesRU from './locales/ru/languageCodes.json';

// Translation resources
const resources = {
  en: {
    common: commonEN,
    auth: authEN,
    onboarding: onboardingEN,
    navigation: navigationEN,
    chat: chatEN,
    review: reviewEN,
    profile: profileEN,
    discovery: discoveryEN,
    cards: cardsEN,
    errors: errorsEN,
    languages: languagesEN,
    levels: levelsEN,
    settings: settingsEN,
    proofread: proofreadEN,
    languageCodes: languageCodesEN,
  },
  zh: {
    common: commonZH,
    auth: authZH,
    onboarding: onboardingZH,
    navigation: navigationZH,
    chat: chatZH,
    review: reviewZH,
    profile: profileZH,
    discovery: discoveryZH,
    cards: cardsZH,
    errors: errorsZH,
    languages: languagesZH,
    levels: levelsZH,
    settings: settingsZH,
    proofread: proofreadZH,
    languageCodes: languageCodesZH,
  },
  ru: {
    common: commonRU,
    auth: authRU,
    onboarding: onboardingRU,
    navigation: navigationRU,
    chat: chatRU,
    review: reviewRU,
    profile: profileRU,
    discovery: discoveryRU,
    cards: cardsRU,
    errors: errorsRU,
    languages: languagesRU,
    levels: levelsRU,
    settings: settingsRU,
    proofread: proofreadRU,
    languageCodes: languageCodesRU,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: getInitialLanguage(), // Set immediately for instant render
    fallbackLng: 'en',
    defaultNS: 'common',

    // Language detection order (still used by LanguageDetector for caching)
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'mellow-ui-language',
    },

    interpolation: {
      escapeValue: false, // React already escapes
    },

    react: {
      useSuspense: true,
    },
  });

export default i18n;

